"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var Command = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "command" },
            react_1.default.createElement("path", { id: "Icon", d: "M8 6V9H10V6H8ZM8 9V15H10V9H8ZM8 15V18H10V15H8ZM6 16H9V14H6V16ZM9 16H15V14H9V16ZM15 16H18V14H15V16ZM16 18V15H14V18H16ZM16 15V9H14V15H16ZM16 9V6H14V9H16ZM18 8H15V10H18V8ZM15 8H9V10H15V8ZM9 8H6V10H9V8ZM6 8C4.89543 8 4 7.10457 4 6H2C2 8.20914 3.79086 10 6 10V8ZM20 6C20 7.10457 19.1046 8 18 8V10C20.2091 10 22 8.20914 22 6H20ZM18 4C19.1046 4 20 4.89543 20 6H22C22 3.79086 20.2091 2 18 2V4ZM16 6C16 4.89543 16.8954 4 18 4V2C15.7909 2 14 3.79086 14 6H16ZM18 20C16.8954 20 16 19.1046 16 18H14C14 20.2091 15.7909 22 18 22V20ZM20 18C20 19.1046 19.1046 20 18 20V22C20.2091 22 22 20.2091 22 18H20ZM18 16C19.1046 16 20 16.8954 20 18H22C22 15.7909 20.2091 14 18 14V16ZM4 18C4 16.8954 4.89543 16 6 16V14C3.79086 14 2 15.7909 2 18H4ZM6 20C4.89543 20 4 19.1046 4 18H2C2 20.2091 3.79086 22 6 22V20ZM8 18C8 19.1046 7.10457 20 6 20V22C8.20914 22 10 20.2091 10 18H8ZM6 4C7.10457 4 8 4.89543 8 6H10C10 3.79086 8.20914 2 6 2V4ZM6 2C3.79086 2 2 3.79086 2 6H4C4 4.89543 4.89543 4 6 4V2Z" }))));
};
exports.default = Command;
